export const keys = {
  me: ['me'] as const,
  bots: ['bots'] as const,
  bot: (id: string) => ['bot', id] as const,
  channels: (botId: string) => ['channels', botId] as const,
  subscriptions: (botId: string, buid: string) => ['subscriptions', botId, buid] as const,
  scopes: (botId: string, buid: string) => ['scopes', botId, buid] as const,
  features: (botId: string, buid: string) => ['features', botId, buid] as const,
  enrollments: (botId: string) => ['enrollments', botId] as const,
  channelKeys: (botId: string, buid: string) => ['apikeys', botId, buid] as const,
  eventsub: ['eventsub'] as const,
  eventsubCatalog: ['catalog', 'eventsub'] as const,
  helixCatalog: ['catalog', 'helix'] as const,
  history: (botId?: string, buid?: string) => ['history', botId ?? '', buid ?? ''] as const,
  logs: (botId?: string, buid?: string) => ['logs', botId ?? '', buid ?? ''] as const,
};
